export default {
  next: 'Suivant',
  confirm: 'Confirmer ma demande',
  confirmMobile: 'Confirmer',
  cancel: 'Annuler',
  close: 'Fermer',
  back: 'Retour',
  continue: 'Continuer',
  to: 'Au',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  other: 'Autre',
  otherStockagesName: {
    storageSpace: 'Garde meuble',
    boxes: 'Box',
    garage: 'Garage',
    attic: 'Grenier',
  },
  currency: '€',
  separator: ',',
  quantity: 'Quantité',
  volume: 'Volume',
  save: 'Sauvegarder',
  dateFormat: 'dd/MM/yyyy',
  yes: 'Oui',
  no: 'Non',
  duno: 'Je ne sais pas',
  disassembly: 'Démontage / Remontage',
  heavy: 'Poids > 100kg',
  valid: 'Valider',
  loading: 'Chargement de l\'application',
  saveAndExit: 'Enregistrer et fermer',
  advices: 'Conseils',
  learnMore: 'En savoir plus',
  delete: 'Supprimer',
  phone: {
    link: '+33182521012',
  },
};
